export class PriorAdapter {
  static toInputDTO(req: any): any {
    return {
      graph_id: req.id,
      status: req.status,
    };
  }

  static toOutputDTO(res: any): any {
    return (
      res.map((attr: any) => ({
        id: attr.graph_id,
        name: attr.title,
        desc: attr.description,
        status: attr.is_default ? "using" : "unused",
        prohibit: attr.prohibited_by.length ? ["layer_rule"] : [],
        updated_at: attr.updated_at,
        created_at: attr.saved_at,
      })) || []
    );
  }
}
